import React, {useEffect, useState, useCallback, useRef} from 'react';
import {ScrollView, TouchableOpacity, View, Modal, Platform} from 'react-native'
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {PrivateStackParamList} from '@routes/types';
import ScreenWrapper from '@hoc/ScreenWrapper';
import {Theme, ThemedText, ThemedView} from "@app/theme";
import CommonHeader from "@sharedComponents/Header/Header";
import Info from "../../../assets/Icons/Info";
import InterestRate from "../../../assets/Icons/InterestRate";
import TenureDate from "../../../assets/Icons/TenureData";
import WorkspacePremium from "../../../assets/Icons/WorkSpacePremium";
import DSPIcon from "../../../assets/Icons/DSPIcon";
import Payments from "../../../assets/Icons/Payments";
import ReceiptLong from "../../../assets/Icons/ReceiptLong";
import DownsideArrow from "../../../assets/Icons/DownsideArrow";
import UpsideArrow from "../../../assets/Icons/UpsideArrow";
import Button from "@sharedComponents/Button/Button";
import {useTheme} from "@shopify/restyle";
import {useAppDispatch, useAppSelector} from "@store/hooks";
import TataIcon from "../../../assets/Icons/TataIcon";
import {
  activateAssetAPI,
  loanOfferDetailsAPICall,
} from '@screens/LoanOffer/services/services';
import {useFocusEffect} from "@react-navigation/native";
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader';
import {addCommasToNumber, trackEvent} from "@app/utils";
import ProcessingChargesBreakUp from "@screens/LoanOffer/components/ProcessingFeeBreakUp";
import { LENDER_ID } from '@app/types/regix';
import BenefitsCelebrationIcon from '../../../assets/Icons/BenefitsCelebrationIcon';
import InterestRateTooltip from '@screens/LoanOffer/components/InterestRateTooltip';
import LoanTenureTooltip from '@screens/LoanOffer/components/LoanTenureTooltip';
import CreditLimitTooltip from '@screens/LoanOffer/components/CreditLimitTooltip';
import handleApiErr from '@app/helper/handleApiErr';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { updateLinkedApplication } from '@app/store/slices/authSlice';
import useIsRedirectionJourney from '@app/hooks/useIsRedirectionJourney';
import { updatePartnerParams } from '@app/store/slices/platformSlice';

export type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'PLEDGE_CONFIRMATION'>;

const LoanOffer = ({navigation, route}: ScreenProps) => {
    const dispatch = useAppDispatch();
    const {isHalfRedirectionJourney} = useIsRedirectionJourney();
    const {colors} = useTheme<Theme>()
    const [oneTimeAccordingClicked, setOneTimeAccordingClicked] = useState(false)
    const [withdrawalAndRepaymentClicked, setWithdrawalAndRepaymentClicked] = useState(false)
    const [prePaymentClicked, setPrePaymentClicked] = useState(false)
    const [loanRegistrationState, setLoanRegistrationState] = useState(false)
    const {userDetails} = useAppSelector(state => state.auth)
    const lenderId = userDetails?.linkedApplications[0]?.lenderAccountId
    const [showInterestTooltip, setShowInterestTooltip] = useState(false);
    const [showLoanTenureToolTip, setShowLoanTenureToolTip] = useState(false);
    const [showCreditLineToolTip, setShowCreditLineToolTip] = useState(false);
    const [pageLoading, setPageLoading] = useState(false)
    const interestInfoIconRef = useRef<TouchableOpacity>(null);
    const loanTenureInfoIconRef = useRef<TouchableOpacity>(null);
    const containerRef = useRef<View>(null);
    const [loanOfferDetails, setLoanOfferDetails] = useState<any>()
    const [proceedCTALoader, setProceedCTALoader] = useState(false)

    const {params} = route;

    const hasStateChanged = params?.hasStateChanged;

    const interestPerMonth = Math.ceil((10000*(loanOfferDetails?.stepResponseObject?.interestRate ?? 0) *30)/(100*365));


    const fetchPledgeLimitData = async () => {
        try{
            const loanOfferDetailsResponse = await loanOfferDetailsAPICall({
                applicationId: userDetails?.linkedApplications[0]?.applicationId
            })
            setLoanOfferDetails(loanOfferDetailsResponse?.data)
        } catch (error: any) {
            if(error?.data?.statusCode && handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: error?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
        }
    }


    const renderOneTimeAccordion = () => {
        return (
            <ThemedView borderRadius={"xs"} backgroundColor={"bg-fill-warning"} padding={"sm"} mt={"md"}>
                <ProcessingChargesBreakUp processingFeeObject = {loanOfferDetails?.stepResponseObject?.processingFeesBreakUp}/>
            </ThemedView>
        )
    }

    const renderWithdrawAndRepaymentAccordion = () => {
        return (
            <ThemedView borderRadius={"xs"} backgroundColor={"bg-fill-warning"} padding={"sm"} mt={"md"}>
                <ThemedView flexDirection={"row"} alignItems={"center"}>
                    <ThemedText variant={"b4r"} color={"text-primary"}>
                        • Withdraw money as per your convenience.
                    </ThemedText>
                </ThemedView>

                <ThemedView flexDirection={"row"} mt={"sm"}>
                  <ThemedText variant={"b4r"} color={"text-primary"}>
                    •
                  </ThemedText>
                    <ThemedText variant={"b4r"} color={"text-primary"} ml={"xs"}>
                        Repay principal amount anytime during the month, no prepayment charges.
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        )
    }
    const renderPrePaymentAccordion = () => {
        return (
            <ThemedView borderRadius={"xs"} backgroundColor={"bg-fill-warning"} padding={"sm"} mt={"md"}>
                <ThemedView flexDirection={"row"} >
                  <ThemedText variant={"b4r"} color={"text-primary"}>
                    •
                  </ThemedText>
                    <ThemedText variant={"b4r"} color={"text-primary"} ml={"xs"}>
                        Close your loan anytime without any additional charges or hidden fees.
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        )
    }


        useEffect(() => {
          
            if (!hasStateChanged || hasStateChanged === true) {
                setPageLoading(true)
                Promise.all([
                    fetchPledgeLimitData()
                ]).finally(() => {
                    setPageLoading(false)
                })
            }
        }, [hasStateChanged]) 

        useEffect(() => {
            dispatch(updatePartnerParams({showCall:true}))
        }, [])

    const handleContinueCTA = async () => {

      setProceedCTALoader(true)
      try {
        const activatePledgeResponse = await activateAssetAPI({
          applicationId: userDetails?.linkedApplications[0]?.applicationId
        })

        const updatedApplicationObj = activatePledgeResponse?.data?.updatedApplicationObj;
        dispatch(updateLinkedApplication(updatedApplicationObj))
        const nextRoute = getNextRoute(updatedApplicationObj.currentStepId, updatedApplicationObj?.applicationState, updatedApplicationObj?.stepStatusMap)

        if(isHalfRedirectionJourney) {
          navigation.reset({
            index: 0,
            routes: [{ name: 'REDIRECTION_JOURNEY_SCREEN' }]
          })
        } else {
            if(Platform.OS === 'web') {
                navigation.navigate(nextRoute)
            } else {
                navigation.reset({
                    index: 0,
                    routes: [{ name: 'HOME' } ,{ name: 'KYC_STEPPER' }, { name: nextRoute }]
                })
            }
        }
        setProceedCTALoader(false)
      } catch (err: any) {
        if(err?.data?.statusCode && handleApiErr(err)) {
            dispatch(showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: err?.data?.message,
                closeOnBackdropPress: true,
                errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                errorHeading: err?.data?.header,
                showErrorHeading: true,
                btnName: 'Ok, got it!',
            }))
        }
        setProceedCTALoader(false)
      }
    }

    const renderLoanRegistrationState = () => {
        return (
            <ThemedView borderRadius={"xs"} backgroundColor={"bg-fill-warning"} padding={"sm"} mt={"md"}>
                <ThemedView flexDirection={"row"} alignItems={"center"}>
                  <ThemedView flexDirection={"row"}  flex={1}>
                    <ThemedText variant={"b4r"} color={"text-primary"}>
                      •
                    </ThemedText>
                    <ThemedText variant={"b4r"} color={"text-primary"} ml={"xs"}>
                      {`Selected state for loan agreement stamp: ${loanOfferDetails?.stepResponseObject?.stampDutyState}. To change the state, \n`}
                      <TouchableOpacity activeOpacity={1} onPress={() => {
                        navigation.navigate("STATE_SELECTION", {
                          stampDutyData: loanOfferDetails?.stepResponseObject?.stampDutyChargesByState,
                          stampDutyState: loanOfferDetails?.stepResponseObject?.stampDutyState
                        })
                      }}>
                        <ThemedText variant={"b4b"} color={"bg-action-primary"}>
                          click here
                        </ThemedText>
                      </TouchableOpacity>
                    </ThemedText>
                  </ThemedView>

                </ThemedView>
            </ThemedView>
        )
    }

    // @ts-ignore
    return (
        <ScreenWrapper screenName={route?.name} screenRef={containerRef} additionalProperties={{newArchRoute: true}}>
            {pageLoading ? <PageLoader/> :
                <ThemedView backgroundColor="bg-surface-page" flex={1}>
                  <TouchableOpacity disabled={Platform.OS !== 'web' && !showInterestTooltip && !showCreditLineToolTip && !showLoanTenureToolTip} activeOpacity={1} onPress={() => {
                    setShowInterestTooltip(false)
                    setShowCreditLineToolTip(false)
                    setShowLoanTenureToolTip(false)
                  }} style={{ flex: 1}}>
                    <CommonHeader label={"Loan offer"} navigation={navigation} pageName={route.name}/>
                    <ScrollView>
                        <ThemedView marginHorizontal={"lg"} borderTopLeftRadius={"lg"} borderTopRightRadius={"lg"}
                                    borderWidth={1} mt={"2xl"}
                                    borderColor={"border-primary"} backgroundColor={"bg-fill-emphasis-secondary"}
                                    paddingHorizontal={"md"} paddingTop={"lg"} paddingBottom={"2xl"}>
                            <ThemedView flexDirection={"row"} justifyContent={"space-between"}>
                                <ThemedView flexDirection={'row'} alignItems={"center"}>
                                    <ThemedText variant={"b3r"} mr={"xs"} color={"text-secondary"}>Credit line amount</ThemedText>
                                    <TouchableOpacity style={{ position: 'relative' }} activeOpacity={1} onPress={() => {
                                        setShowInterestTooltip(false)
                                        setShowLoanTenureToolTip(false)
                                        setShowCreditLineToolTip(!showCreditLineToolTip)
                                        trackEvent('PLEDGE_CONFIRMATION_CREDIT_LINE_AMOUNT_TOOLTIP_CLICKED')
                                    }}>
                                        <Info/>
                                        {showCreditLineToolTip && <CreditLimitTooltip onClose={() => {
                                          setShowCreditLineToolTip(false);
                                        }} />}
                                    </TouchableOpacity>
                                </ThemedView>
                                <ThemedText variant={"h2b"} color={"text-emphasis-secondary"}>
                                  <ThemedText fontFamily='Inter' variant={"h2b"} color={"text-emphasis-secondary"}>₹</ThemedText>
                                    {`${addCommasToNumber(loanOfferDetails?.stepResponseObject?.requestCreditLimit)}`}
                                </ThemedText>

                            </ThemedView>
                        </ThemedView>
                        <ThemedView marginHorizontal={"lg"} borderBottomLeftRadius={"lg"} borderBottomRightRadius={"lg"}
                                    borderWidth={1}
                                    borderColor={"border-primary"} paddingHorizontal={"2xl"} paddingTop={"lg"}
                                    paddingBottom={"xl"} backgroundColor={"bg-fill-primary"} zIndex={-1}>
                            <ThemedView flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} zIndex={-1}>
                                <ThemedView flexDirection={"row"} alignItems={"center"} zIndex={-1}>
                                    <InterestRate/>
                                    <ThemedView ml={"sm"}>
                                        <ThemedText variant={"b4r"} color={"text-secondary"}>
                                            Interest rate
                                        </ThemedText>
                                        <ThemedView flexDirection={"row"} alignItems={"center"}>
                                            <ThemedText variant={"b3s"} color={"text-emphasis-secondary"} mr={"xs"}>
                                                {loanOfferDetails?.stepResponseObject?.interestRate}%
                                            </ThemedText>
                                            <TouchableOpacity
                                              style={{ position: 'relative' }}
                                              ref={interestInfoIconRef}
                                              activeOpacity={1}
                                              onPress={() => {
                                                 setShowCreditLineToolTip(false)
                                                 setShowLoanTenureToolTip(false)
                                                 setShowInterestTooltip(!showInterestTooltip)
                                                 trackEvent('PLEDGE_CONFIRMATION_INTEREST_RATE_TOOLTIP_CLICKED')
                                              }}
                                            >
                                              <Info/>
                                              {showInterestTooltip && <InterestRateTooltip calculateInterest={interestPerMonth} onClose={() => {
                                                setShowInterestTooltip(false);
                                              }} />}
                                            </TouchableOpacity>
                                        </ThemedView>


                                    </ThemedView>

                                </ThemedView>

                                <ThemedView flexDirection={"row"} justifyContent={"space-between"}
                                            alignItems={"center"}>
                                    <ThemedView flexDirection={"row"} alignItems={"center"}>
                                        <TenureDate/>
                                        <ThemedView ml={"sm"}>
                                            <ThemedText variant={"b4r"} color={"text-secondary"}>
                                                Loan tenure
                                            </ThemedText>
                                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                                <ThemedText variant={"b3s"} color={"text-emphasis-secondary"} mr={"xs"}>
                                                    {loanOfferDetails?.stepResponseObject?.loanTenureInMonths} months
                                                </ThemedText>
                                                <TouchableOpacity style={{ position: 'relative' }} activeOpacity={1} ref={loanTenureInfoIconRef} onPress={() => {
                                                  setShowInterestTooltip(false)
                                                  setShowCreditLineToolTip(false)
                                                  setShowLoanTenureToolTip(!showLoanTenureToolTip)
                                                  trackEvent('PLEDGE_CONFIRMATION_LOAN_TENURE_TOOLTIP_CLICKED')
                                                }}>
                                                    <Info/>
                                                    {showLoanTenureToolTip && <LoanTenureTooltip onClose={() => {
                                                      setShowLoanTenureToolTip(false);
                                                    }} duration={loanOfferDetails?.stepResponseObject?.loanTenureInMonths} />}
                                                </TouchableOpacity>
                                            </ThemedView>


                                        </ThemedView>

                                    </ThemedView>

                                </ThemedView>
                            </ThemedView>
                        </ThemedView>
<ThemedView zIndex={-10}>
  <ThemedText marginHorizontal={"lg"} variant={"h5s"} color={"text-primary"} mt={"lg"}>
    Benefits for you
  </ThemedText>
</ThemedView>

                        <ThemedView marginHorizontal={"lg"} borderWidth={1} borderRadius={"sm"} zIndex={-10}
                                    borderColor={"border-primary"} justifyContent={"space-between"}
                                    alignItems={"center"}
                                    mt={"md"} backgroundColor={"bg-fill-primary"}
                                    paddingVertical={"sm"} paddingLeft={"sm"} paddingRight={"sm"} flexDirection={"row"}>
                            <ThemedView flexDirection={"row"} alignItems={"center"} zIndex={-1}>
                                <WorkspacePremium color={colors['icon-action-primary']} />
                                <ThemedText variant={"b4r"} color={"text-primary"} ml={"md"}>
                                    Trusted lending partner
                                </ThemedText>
                            </ThemedView>

                            {lenderId?.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? <TataIcon/> : <DSPIcon/>}

                        </ThemedView>


                        <ThemedView marginHorizontal={"lg"} borderWidth={1} borderRadius={"sm"}
                                    backgroundColor={"bg-fill-primary"}
                                    borderColor={"border-primary"} justifyContent={"space-between"}
                                    alignItems={"center"}
                                    mt={"sm"}
                                    paddingVertical={"sm"} paddingLeft={"sm"} paddingRight={"sm"} flexDirection={"row"}>
                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                <BenefitsCelebrationIcon color={colors['icon-action-primary']} />
                                <ThemedText variant={"b4r"} color={"text-primary"} ml={"sm"}>
                                    Make unlimited withdrawals & repay anytime
                                </ThemedText>
                            </ThemedView>

                        </ThemedView>


                        <ThemedView marginHorizontal={"lg"} borderWidth={1} borderRadius={"sm"}
                                    backgroundColor={"bg-fill-primary"}
                                    borderColor={"border-primary"} justifyContent={"space-between"}
                                    alignItems={"center"}
                                    mt={"sm"}
                                    paddingVertical={"sm"} paddingLeft={"sm"} paddingRight={"sm"} flexDirection={"row"}>
                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                <Payments color={colors['icon-action-primary']} />
                                <ThemedText variant={"b4r"} color={"text-primary"} ml={"sm"}>
                                    Pay interest only on net withdrawn amount
                                </ThemedText>
                            </ThemedView>


                        </ThemedView>


                        <ThemedView marginHorizontal={"lg"} borderWidth={1} borderRadius={"sm"}
                                    backgroundColor={"bg-fill-primary"}
                                    borderColor={"border-primary"} justifyContent={"space-between"}
                                    alignItems={"center"}
                                    mt={"sm"}
                                    paddingVertical={"sm"} paddingLeft={"sm"} paddingRight={"sm"} flexDirection={"row"}>
                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                <ReceiptLong color={colors['icon-action-primary']} />
                                <ThemedText variant={"b4r"} color={"text-primary"} ml={"md"}>
                                    Pay interest monthly and principal at your ease
                                </ThemedText>
                            </ThemedView>
                        </ThemedView>


                        <ThemedView height={1} backgroundColor={"border-primary"} mt={"lg"}/>
                        <ThemedView borderColor={"border-primary"} backgroundColor={"bg-fill-primary"}>
                            <ThemedView mt={"lg"} marginHorizontal={"lg"}>
                                <ThemedText variant={"h5s"} color={"text-primary"}>
                                    Charges & other details
                                </ThemedText>
                                <ThemedView>
                                    <TouchableOpacity activeOpacity={1} onPress={() => {
                                        setOneTimeAccordingClicked(!oneTimeAccordingClicked)
                                        if(!oneTimeAccordingClicked) {
                                            trackEvent('PLEDGE_CONFIRMATION_CHARGES_EXPANDED')
                                        } else {
                                            trackEvent('PLEDGE_CONFIRMATION_CHARGES_COLLAPSED')
                                        }
                                    }}>
                                        <ThemedView flexDirection={"row"} justifyContent={"space-between"}
                                                    alignItems={"center"}
                                                    mt={"lg"}>
                                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                                {oneTimeAccordingClicked ? <UpsideArrow/> : <DownsideArrow/>}
                                                <ThemedText variant={"b3r"} color={"text-primary"}
                                                            ml={"sm"}>{lenderId.toUpperCase() === LENDER_ID.TATA.toUpperCase() ? 'One time charges (excl. of GST)' : 'One time charges'}</ThemedText>
                                            </ThemedView>
                                            <ThemedText variant={"b3s"} color={"text-primary"}>
                                                {`₹${addCommasToNumber(loanOfferDetails?.stepResponseObject?.totalProcessingFees)}`}
                                            </ThemedText>

                                        </ThemedView>
                                    </TouchableOpacity>
                                    {oneTimeAccordingClicked && renderOneTimeAccordion()}

                                </ThemedView>

                                <ThemedView height={1} backgroundColor={"border-primary"} marginVertical={"md"}/>

                                <ThemedView>
                                    <TouchableOpacity activeOpacity={1} onPress={() => {
                                        setWithdrawalAndRepaymentClicked(!withdrawalAndRepaymentClicked)
                                        if(!withdrawalAndRepaymentClicked) {
                                            trackEvent('PLEDGE_CONFIRMATION_WITHDRAWAL_AND_REPAYMENT_EXPANDED')
                                        } else {
                                            trackEvent('PLEDGE_CONFIRMATION_WITHDRAWAL_AND_REPAYMENT_COLLAPSED')
                                        }
                                    }}>
                                        <ThemedView flexDirection={"row"} justifyContent={"space-between"}
                                                    alignItems={"center"}>
                                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                                {withdrawalAndRepaymentClicked ? <UpsideArrow/> : <DownsideArrow/>}
                                                <ThemedText variant={"b3r"} color={"text-primary"} ml={"sm"}>Withdrawal
                                                    &
                                                    repayment</ThemedText>
                                            </ThemedView>
                                            <ThemedText variant={"b3s"} color={"text-primary"}>
                                                Flexi
                                            </ThemedText>

                                        </ThemedView>
                                    </TouchableOpacity>
                                    {withdrawalAndRepaymentClicked && renderWithdrawAndRepaymentAccordion()}
                                </ThemedView>

                                <ThemedView height={1} backgroundColor={"border-primary"} marginVertical={"md"}/>

                                <ThemedView>
                                    <TouchableOpacity activeOpacity={1} onPress={() => {
                                        setPrePaymentClicked(!prePaymentClicked)
                                        if(!prePaymentClicked) {
                                            trackEvent('PLEDGE_CONFIRMATION_PRE_PAYMENT_EXPANDED')
                                        } else {
                                            trackEvent('PLEDGE_CONFIRMATION_PRE_PAYMENT_COLLAPSED')
                                        }
                                    }}>
                                        <ThemedView flexDirection={"row"} justifyContent={"space-between"}
                                                    alignItems={"center"}>
                                            <ThemedView flexDirection={"row"} alignItems={"center"}>
                                                {prePaymentClicked ? <UpsideArrow/> : <DownsideArrow/>}
                                                <ThemedText variant={"b3r"} color={"text-primary"}
                                                            ml={"sm"}>Pre-payment</ThemedText>
                                            </ThemedView>
                                            <ThemedText variant={"b3s"} color={"text-primary"}>
                                                Free
                                            </ThemedText>

                                        </ThemedView>
                                    </TouchableOpacity>
                                    {prePaymentClicked && renderPrePaymentAccordion()}

                                </ThemedView>

                                {lenderId === "Tata" &&
                                    <ThemedView>
                                        <ThemedView height={1} backgroundColor={"border-primary"}
                                                    marginVertical={"md"}/>
                                        <ThemedView>
                                            <TouchableOpacity activeOpacity={1} onPress={() => {
                                                setLoanRegistrationState(!loanRegistrationState)
                                                if(loanRegistrationState) {
                                                    trackEvent('PLEDGE_CONFIRMATION_LOAN_REGISTRATION_STATE_CLICKED')
                                                }
                                            }}>
                                                <ThemedView flexDirection={"row"} justifyContent={"space-between"}
                                                            alignItems={"center"}>
                                                    <ThemedView flexDirection={"row"} alignItems={"center"}>
                                                        {loanRegistrationState ? <UpsideArrow/> : <DownsideArrow/>}
                                                        <ThemedText variant={"b3r"} color={"text-primary"} ml={"sm"}>Loan registration state</ThemedText>
                                                    </ThemedView>
                                                    <ThemedText variant={"b3s"} color={"text-primary"}>
                                                        {loanOfferDetails?.stepResponseObject?.stampDutyState}
                                                    </ThemedText>

                                                </ThemedView>
                                            </TouchableOpacity>
                                            {loanRegistrationState && renderLoanRegistrationState()}

                                        </ThemedView>
                                    </ThemedView>
                                }

                                <ThemedText variant={"b4r"} color={"text-secondary"} textAlign={"center"} mt={"xl"}>Account
                                    creation/withdrawals are subject to lender approval</ThemedText>

                            </ThemedView>
                            <ThemedView mt={"lg"} backgroundColor={"bg-fill-emphasis-secondary"}
                                        paddingVertical={"sm"}>
                                <ThemedText variant={"b4s"} color={"text-secondary"} textAlign={"center"}>NO HIDDEN
                                    CHARGES</ThemedText>
                            </ThemedView>
                        </ThemedView>


                    </ScrollView>

                    <ThemedView
                        style={{width: '100%'}}
                        bg='bg-surface-primary'
                        padding='lg'
                        borderTopWidth={1}
                        borderTopColor='border-primary'
                    >

                        <Button
                            eventName='LOAN_OFFER_PROCEED_CLICKED'
                            label="Proceed"
                            type="SOLID"
                            size='MD'
                            disabled={false}
                            handlePress={handleContinueCTA}
                            bg={colors['bg-action-primary']}
                            textColor={colors['text-primary']}
                            buttonLoader={proceedCTALoader}
                        />
                    </ThemedView>
                  </TouchableOpacity>
                </ThemedView>
            }

                </ScreenWrapper>
                )
            };

export default LoanOffer;
